import { render, staticRenderFns } from "./students-push.vue?vue&type=template&id=3443b90b&scoped=true&"
import script from "./students-push.vue?vue&type=script&lang=js&"
export * from "./students-push.vue?vue&type=script&lang=js&"
import style0 from "./students-push.vue?vue&type=style&index=0&id=3443b90b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443b90b",
  null
  
)

export default component.exports